import {
  OnChanges,
  SimpleChanges,
  Directive,
  forwardRef,
  Inject,
  Optional,
  Self
} from '@angular/core';

import {StringMapWrapper} from '../../facade/collection';
import {EventEmitter, ObservableWrapper} from '../../facade/async';

import {NgControl} from './ng_control';
import {Control} from '../model';
import {NG_VALIDATORS, NG_ASYNC_VALIDATORS} from '../validators';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from './control_value_accessor';
import {
  setUpControl,
  composeValidators,
  composeAsyncValidators,
  isPropertyUpdated,
  selectValueAccessor
} from './shared';
import {ValidatorFn, AsyncValidatorFn} from './validators';

export const formControlBinding: any =
    /*@ts2dart_const*/ /* @ts2dart_Provider */ {
      provide: NgControl,
      useExisting: forwardRef(() => NgFormControl)
    };
export class NgFormControl extends NgControl implements OnChanges {
  form: Control;
  update = new EventEmitter();
  model: any;
  viewModel: any;

  constructor( private _validators:
                  /* Array<Validator|Function> */ any[], private _asyncValidators:
                  /* Array<Validator|Function> */ any[],
              valueAccessors: ControlValueAccessor[]) {
    super();
    this.valueAccessor = selectValueAccessor(this, valueAccessors);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._isControlChanged(changes)) {
      setUpControl(this.form, this);
      this.form.updateValueAndValidity({emitEvent: false});
    }
    if (isPropertyUpdated(changes, this.viewModel)) {
      this.form.updateValue(this.model);
      this.viewModel = this.model;
    }
  }

  get path(): string[] { return []; }

  get validator(): ValidatorFn { return composeValidators(this._validators); }

  get asyncValidator(): AsyncValidatorFn { return composeAsyncValidators(this._asyncValidators); }

  get control(): Control { return this.form; }

  viewToModelUpdate(newValue: any): void {
    this.viewModel = newValue;
    ObservableWrapper.callEmit(this.update, newValue);
  }

  private _isControlChanged(changes: {[key: string]: any}): boolean {
    return StringMapWrapper.contains(changes, "form");
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngFormControl]',
  providers: [formControlBinding],
  inputs: ['form: ngFormControl', 'model: ngModel'],
  outputs: ['update: ngModelChange'],
  exportAs: 'ngForm'
}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_VALIDATORS, ] }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_ASYNC_VALIDATORS, ] }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_VALUE_ACCESSOR, ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
